<template lang="pug">
    left-panel-layout.legal-left-panel(v-bind="$attrs" :menu="menu" ref="modal")
</template>

<script>
import EventBus from '../../lib/event-bus'
import Events from '../../lib/events'
import ModalsList from './modals-list'

export default {
    name: 'legal-left-panel',

    computed: {
        menu() {
            return [
                { name: 'Privacy Policy', route: {path: '/privacy-policy', target: '_blank'} },
                { name: 'Terms of Use', route: {path: '/terms-of-use', target: '_blank'} },
                { name: 'Terms of Sale', route: {path: '/terms-of-sale', target: '_blank'} },
                { name: 'GDPR Cookie Policy', route: {path: '/cookie-policy', target: '_blank'} },
                { name: 'GDPR Info Request', click: this.infoRequest },
            ]
        },
    },

    methods: {
        infoRequest() {
            EventBus.$emit(Events.OPEN_MODAL, ModalsList.GDPR_REQUEST)
        },
    },
}
</script>
